module["exports"] = [
  "Pty Ltd",
  "and Sons",
  "Corp",
  "Group",
  "Brothers",
  "Partners"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/en_AU/company/suffix.js
// module id = 1371
// module chunks = 0